<template>
  <div class="config-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="config-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">参数设置</span>
            </div>
          </template>
        </van-nav-bar>

        <div class="content-area">
          <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
            <van-tab title="定时设置">
              <div class="tab-content">
                <div class="group-list">
                  <div v-for="g in setGroups" :key="'g-' + g.i" class="group-card" :class="{ 'group-disabled': !g.en }">
                    <div class="group-head">
                      <span class="group-name">组 {{ g.i }}</span>
                      <div class="group-head-right">
                        <span class="group-flag" :class="g.en ? 'flag-on' : 'flag-off'">{{ g.en ? '启用' : '停用' }}</span>
                        <van-switch :value="g.en === 1" size="20" @input="onGroupEn(g, $event)" />
                      </div>
                    </div>
                    <div class="group-summary" @click="editGroupCard(g)">
                      <div class="summary-row">
                        <span class="summary-label">时间段</span>
                        <span class="summary-value">{{ pad2(g.h1) + ':' + pad2(g.m1) + ' - ' + pad2(g.h2) + ':' + pad2(g.m2) }}</span>
                      </div>
                      <div class="summary-row">
                        <span class="summary-label">间隔</span>
                        <span class="summary-value" :class="{ 'summary-muted': !g.iv }">
                          {{ g.iv ? formatSec(g.ion) + ' / ' + formatSec(g.ioff) : '未启用' }}
                        </span>
                      </div>
                      <div class="summary-row">
                        <span class="summary-label">工作日</span>
                        <span class="summary-value">{{ wkText(g.wk) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="add-group-btn" :disabled="!canAddGroup" @click="addGroup">
                  <van-icon name="plus" size="16" />
                  <span>添加定时</span>
                </button>
                <div v-if="!canAddGroup" class="config-tip config-tip--center">最多支持 10 组定时，删除后可再添加</div>
                <div class="config-tip">时间段必填且不允许跨天、不允许与其他组重叠（紧挨可以）。单次执行：工作日全部不选时，该组在新建或设备重启后执行一次，走完时间段自动停用。多组同时命中时任一组要求开即开。</div>
              </div>
            </van-tab>

            <van-tab title="信号保护">
              <div class="tab-content">
                <div class="config-card">
                  <div class="config-card-header">
                    <div class="header-dot"></div>
                    <span>信号保护</span>
                    <button class="card-save-btn" :disabled="loading" @click="saveSig">
                      {{ loading ? '保存中...' : '保存参数' }}
                    </button>
                  </div>
                  <div class="config-card-body">
                    <div class="config-field">
                      <span class="config-field-label">输入信号保护</span>
                      <van-switch v-model="sigEn" size="20" />
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field">
                      <span class="config-field-label">恢复方式</span>
                      <van-radio-group v-model="sigRcv" direction="horizontal" class="config-radio">
                        <van-radio :name="1">自动恢复</van-radio>
                        <van-radio :name="0">手动恢复</van-radio>
                      </van-radio-group>
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field">
                      <span class="config-field-label">有效电平</span>
                      <van-radio-group v-model="sigLvl" direction="horizontal" class="config-radio">
                        <van-radio :name="0">低=异常</van-radio>
                        <van-radio :name="1">高=异常</van-radio>
                      </van-radio-group>
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field config-field-stepper">
                      <div class="stepper-label-wrap">
                        <span class="config-field-label">异常确认延迟(秒)</span>
                      </div>
                      <van-stepper v-model="sigOn" :min="1" :max="30" :step="1" integer />
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field config-field-stepper">
                      <div class="stepper-label-wrap">
                        <span class="config-field-label">恢复确认延迟(秒)</span>
                        <span class="stepper-desc">建议大于异常延迟，抗水膜反复桥接</span>
                      </div>
                      <van-stepper v-model="sigOff" :min="1" :max="30" :step="1" integer />
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field">
                      <span class="config-field-label">蜂鸣报警</span>
                      <van-switch v-model="buzzEn" size="20" />
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-field">
                      <span class="config-field-label">微信报警通知</span>
                      <van-switch v-model="wechatEn" size="20" />
                    </div>
                  </div>
                </div>
                <div class="config-tip">
                  保护开启后，输出 = 定时/手动请求 且 信号允许。手动恢复：信号异常切断后锁定，需按设备按键或重新下发"开"来恢复（断电不丢失）。有效电平选"高=异常"并配合常闭浮球，可实现断线报警。
                </div>
              </div>
            </van-tab>


          </van-tabs>
        </div>
      </div>
    </van-pull-refresh>

    <van-popup v-model="showEditPopup" position="bottom" round class="schedule-popup">
      <div class="popup-header">
        <span class="popup-title">{{ editGroup ? '组 ' + editGroup.i + ' 定时配置' : '定时配置' }}</span>
        <van-icon name="cross" size="18" color="#94a3b8" @click="showEditPopup = false" />
      </div>
      <div v-if="editGroup" class="popup-body">
        <div class="config-item" @click="openTimePicker('start')">
          <span class="config-label">开始时间</span>
          <div class="time-trigger">
            <span>{{ pad2(editGroup.h1) }}:{{ pad2(editGroup.m1) }}</span>
            <van-icon name="arrow" size="14" color="#94a3b8" />
          </div>
        </div>
        <div class="config-divider"></div>
        <div class="config-item" @click="openTimePicker('end')">
          <span class="config-label">结束时间</span>
          <div class="time-trigger">
            <span>{{ pad2(editGroup.h2) }}:{{ pad2(editGroup.m2) }}</span>
            <van-icon name="arrow" size="14" color="#94a3b8" />
          </div>
        </div>
        <div class="popup-tip">时间段必填，结束时间必须晚于开始时间（不允许跨天）；与其他组重叠会被拒绝，紧挨可以</div>
        <div class="config-divider"></div>
        <div class="config-item">
          <span class="config-label">间隔循环</span>
          <van-switch v-model="editGroup.ivBool" size="22" />
        </div>
        <template v-if="editGroup.ivBool">
          <div class="config-divider"></div>
          <div class="config-item" @click="openDurPicker('ion')">
            <span class="config-label">开启时长</span>
            <div class="time-trigger">
              <span>{{ formatSec(editGroup.ion) }}</span>
              <van-icon name="arrow" size="14" color="#94a3b8" />
            </div>
          </div>
          <div class="config-divider"></div>
          <div class="config-item" @click="openDurPicker('ioff')">
            <span class="config-label">关闭时长</span>
            <div class="time-trigger">
              <span>{{ formatSec(editGroup.ioff) }}</span>
              <van-icon name="arrow" size="14" color="#94a3b8" />
            </div>
          </div>
          <div class="popup-tip">进入时间段时从开输出开始循环，退出时间段直接关输出；未开启间隔或时长为 0 则时间段内常开</div>
        </template>
        <div class="config-divider"></div>
        <div class="weekday-section">
          <div class="section-title">
            <span>工作日</span>
            <span class="section-hint">{{ editGroup.wk === 0 ? '全不选 = 单次执行' : '' }}</span>
          </div>
          <div class="day-selector">
            <div
              v-for="(label, i) in weekdays"
              :key="i"
              class="day-btn"
              :class="isWeekdayActive(i) ? 'active' : 'inactive'"
              @click="toggleWeekday(i)"
            >{{ label }}</div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <button v-if="editGroup && !editGroup.isNew" class="popup-btn popup-btn--danger" @click="deleteGroup">删除定时</button>
        <button class="popup-btn popup-btn--cancel" @click="showEditPopup = false">取消</button>
        <button class="popup-btn popup-btn--confirm" @click="confirmGroup">保存</button>
      </div>
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom" round>
      <van-datetime-picker v-model="timePickerCurrent" type="time" :min-hour="0" :max-hour="23" :min-minute="0" :max-minute="59"
        @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
    </van-popup>

    <van-popup v-model="showDurPicker" position="bottom" round>
      <van-picker
        ref="durPicker"
        show-toolbar
        :title="durPickerTarget === 'ion' ? '开启时长' : '关闭时长'"
        :columns="durColumns"
        @confirm="onDurConfirm"
        @cancel="showDurPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "KS2Config",
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      activeTab: 0,
      isLoading: false,
      loading: false,

      groups: [],

      sigEn: true,
      sigRcv: 1,
      sigLvl: 0,
      sigOn: 2,
      sigOff: 10,
      buzzEn: true,
      wechatEn: true,

      weekdays: ['一', '二', '三', '四', '五', '六', '日'],

      showEditPopup: false,
      editGroup: null,

      showTimePicker: false,
      timePickerTarget: "",
      timePickerCurrent: "08:00",

      showDurPicker: false,
      durPickerTarget: "",
      durColumns: [],
    };
  },
  computed: {
    setGroups() {
      return this.groups.filter((g) => g.set === 1);
    },
    canAddGroup() {
      return this.setGroups.length < 10;
    },
  },
  mounted() {
    this.GetDevData(this.did);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
            this.loadConfig(response.data.config || {});
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { });
    },
    defaultGroup(i) {
      return { i, set: 0, en: 0, h1: 8, m1: 0, h2: 22, m2: 0, iv: 0, ion: 300, ioff: 600, wk: 127 };
    },
    loadConfig(cfg) {
      this.sigEn = cfg.sig_en === 1;
      this.sigRcv = cfg.sig_rcv != null ? Number(cfg.sig_rcv) : 1;
      this.sigLvl = cfg.sig_lvl != null ? Number(cfg.sig_lvl) : 0;
      this.sigOn = (cfg.sig_dly && cfg.sig_dly[0] != null) ? Number(cfg.sig_dly[0]) : 2;
      this.sigOff = (cfg.sig_dly && cfg.sig_dly[1] != null) ? Number(cfg.sig_dly[1]) : 10;
      this.buzzEn = cfg.buzzer_enable != null ? cfg.buzzer_enable === 1 : true;
      this.wechatEn = cfg.wechat_alarm != null ? cfg.wechat_alarm === 1 : true;

      // 10 组定时：[i,set,en,h1,m1,h2,m2,iv,ion,ioff,wk]
      const list = [];
      for (let i = 1; i <= 10; i++) {
        const item = Array.isArray(cfg.sch) ? cfg.sch.find((x) => x[0] === i) : null;
        if (item) {
          list.push({
            i,
            set: item[1], en: item[2],
            h1: item[3], m1: item[4], h2: item[5], m2: item[6],
            iv: item[7], ion: item[8] || 300, ioff: item[9] || 600,
            wk: item[10],
          });
        } else {
          list.push(this.defaultGroup(i));
        }
      }
      this.groups = list;
    },
    onReflash() {
      this.devrefresh();
    },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KS-2",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { this.isLoading = false; });
    },
    pad2(n) {
      return String(Number(n) || 0).padStart(2, "0");
    },
    formatSec(total) {
      const t = Number(total) || 0;
      const h = Math.floor(t / 3600);
      const m = Math.floor((t % 3600) / 60);
      const s = t % 60;
      return `${this.pad2(h)}:${this.pad2(m)}:${this.pad2(s)}`;
    },
    wkText(wk) {
      const w = Number(wk) || 0;
      if (w === 0) return "单次执行";
      if (w === 127) return "每天";
      const names = [];
      for (let i = 0; i < 7; i++) {
        if ((w >> i) & 1) names.push(this.weekdays[i]);
      }
      return names.length ? "周" + names.join(" ") : "单次执行";
    },
    groupPayload(g, extra) {
      const sch = {
        i: g.i,
        set: g.set ? 1 : 0,
        en: g.en ? 1 : 0,
        h1: g.h1, m1: g.m1, h2: g.h2, m2: g.m2,
        iv: g.iv ? 1 : 0,
        ion: g.ion, ioff: g.ioff,
        wk: g.wk & 127,
      };
      const config = { sch };
      if (extra) Object.assign(config, extra);
      return {
        did: this.did,
        d_type: "KS-2",
        config: JSON.stringify(config),
      };
    },
    addGroup() {
      if (!this.canAddGroup) return;
      const free = this.groups.find((g) => g.set !== 1);
      if (!free) return;
      const def = this.defaultGroup(free.i);
      this.editGroup = {
        i: def.i,
        isNew: true,
        en: 1,
        h1: def.h1, m1: def.m1, h2: def.h2, m2: def.m2,
        iv: def.iv,
        ivBool: def.iv === 1,
        ion: def.ion, ioff: def.ioff,
        wk: def.wk,
      };
      this.showEditPopup = true;
    },
    onGroupEn(g, val) {
      this.sendConfig(this.groupPayload(Object.assign({}, g, { en: val ? 1 : 0 })), () => {
        g.en = val ? 1 : 0;
      });
    },
    editGroupCard(g) {
      this.editGroup = {
        i: g.i,
        isNew: false,
        en: g.en,
        h1: g.h1, m1: g.m1, h2: g.h2, m2: g.m2,
        iv: g.iv,
        ivBool: g.iv === 1,
        ion: g.ion, ioff: g.ioff,
        wk: g.wk,
      };
      this.showEditPopup = true;
    },
    openTimePicker(target) {
      this.timePickerTarget = target;
      if (target === "start") {
        this.timePickerCurrent = this.pad2(this.editGroup.h1) + ":" + this.pad2(this.editGroup.m1);
      } else {
        this.timePickerCurrent = this.pad2(this.editGroup.h2) + ":" + this.pad2(this.editGroup.m2);
      }
      this.showTimePicker = true;
    },
    onTimeConfirm() {
      const parts = String(this.timePickerCurrent).split(":");
      const h = parseInt(parts[0], 10) || 0;
      const m = parseInt(parts[1], 10) || 0;
      if (this.timePickerTarget === "start") {
        this.editGroup.h1 = h;
        this.editGroup.m1 = m;
      } else {
        this.editGroup.h2 = h;
        this.editGroup.m2 = m;
      }
      this.showTimePicker = false;
    },
    genRange(n) {
      return Array.from({ length: n }, (_, i) => String(i).padStart(2, "0"));
    },
    openDurPicker(target) {
      this.durPickerTarget = target;
      const t = Number(target === "ion" ? this.editGroup.ion : this.editGroup.ioff) || 0;
      const h = Math.floor(t / 3600);
      const m = Math.floor((t % 3600) / 60);
      const s = t % 60;
      this.durColumns = [
        { values: this.genRange(24) },
        { values: this.genRange(60) },
        { values: this.genRange(60) },
      ];
      this.showDurPicker = true;
      this.$nextTick(() => {
        const picker = this.$refs.durPicker;
        picker && picker.setIndexes([h, m, s]);
      });
    },
    onDurConfirm(values) {
      const [h, m, s] = values.map((v) => parseInt(v, 10) || 0);
      const total = h * 3600 + m * 60 + s;
      if (this.durPickerTarget === "ion") {
        this.editGroup.ion = total;
      } else {
        this.editGroup.ioff = total;
      }
      this.showDurPicker = false;
    },
    toggleWeekday(idx) {
      if (!this.editGroup) return;
      this.editGroup.wk ^= (1 << idx);
      this.editGroup.wk &= 127;
    },
    isWeekdayActive(idx) {
      if (!this.editGroup) return false;
      return (this.editGroup.wk >> idx) & 1;
    },
    confirmGroup() {
      const e = this.editGroup;
      const s0 = Number(e.h1) * 60 + Number(e.m1);
      const e0 = Number(e.h2) * 60 + Number(e.m2);
      if (s0 >= e0) {
        this.$toast.fail("结束时间必须晚于开始时间（不允许跨天）");
        return;
      }
      for (const g of this.setGroups) {
        if (g.i === e.i) continue;
        const s1 = Number(g.h1) * 60 + Number(g.m1);
        const e1 = Number(g.h2) * 60 + Number(g.m2);
        if (s0 < e1 && s1 < e0) {
          this.$toast.fail("与组 " + g.i + " 时间段重叠");
          return;
        }
      }
      if (e.ivBool && (!e.ion || !e.ioff)) {
        this.$toast.fail("开启与关闭时长需大于 0");
        return;
      }
      const payload = this.groupPayload({
        i: e.i,
        set: 1,
        en: e.en,
        h1: e.h1, m1: e.m1, h2: e.h2, m2: e.m2,
        iv: e.ivBool ? 1 : 0,
        ion: e.ion, ioff: e.ioff,
        wk: e.wk,
      });
      this.sendConfig(payload, () => {
        const g = this.groups.find((x) => x.i === e.i);
        if (g) {
          g.set = 1;
          g.en = e.en ? 1 : 0;
          g.h1 = e.h1; g.m1 = e.m1; g.h2 = e.h2; g.m2 = e.m2;
          g.iv = e.ivBool ? 1 : 0;
          g.ion = e.ion; g.ioff = e.ioff;
          g.wk = e.wk & 127;
        }
        this.showEditPopup = false;
        this.$toast.success("组 " + e.i + " 已保存");
      });
    },
    deleteGroup() {
      const e = this.editGroup;
      this.$dialog.confirm({
        title: "删除定时",
        message: "确定删除组 " + e.i + " 的定时配置？",
      }).then(() => {
        const payload = {
          did: this.did,
          d_type: "KS-2",
          config: JSON.stringify({ sch: { i: e.i, set: 0 } }),
        };
        this.sendConfig(payload, () => {
          const g = this.groups.find((x) => x.i === e.i);
          if (g) Object.assign(g, this.defaultGroup(e.i));
          this.showEditPopup = false;
          this.$toast.success("组 " + e.i + " 已删除");
        });
      }).catch(() => { });
    },
    saveSig() {
      const payload = {
        did: this.did,
        d_type: "KS-2",
        config: JSON.stringify({
          sig_en: this.sigEn ? 1 : 0,
          sig_rcv: Number(this.sigRcv),
          sig_lvl: Number(this.sigLvl),
          sig_dly: [Number(this.sigOn), Number(this.sigOff)],
          buzzer_enable: this.buzzEn ? 1 : 0,
          wechat_alarm: this.wechatEn ? 1 : 0,
        }),
      };
      this.sendConfig(payload);
    },
    sendConfig(payload, onSuccess) {
      this.loading = true;
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify(payload))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            if (typeof onSuccess === "function") {
              onSuccess();
            } else {
              this.$toast.success("设置已保存");
              this.GetDevData(this.did);
            }
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("保存失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast.fail("保存失败");
        });
    },
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}

.config-radio .van-radio__label {
  font-size: 13px;
}

.config-radio .van-radio__icon--checked .van-icon {
  background-color: #2dd4bf;
  border-color: #2dd4bf;
}

.schedule-popup {
  font-family: "Inter", "Noto Sans SC", sans-serif;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.config-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.content-area {
  padding: 12px;
}

.tab-content {
  padding-top: 8px;
}

.config-block {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 22px;
  gap: 12px;
}

.config-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex-shrink: 0;
}

.config-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.config-item-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:deep(.van-stepper__minus),
:deep(.van-stepper__plus) {
  color: #2dd4bf;
  border-color: #2dd4bf;
}

:deep(.van-stepper__minus:active),
:deep(.van-stepper__plus:active) {
  background-color: #ccfbf1;
}

:deep(.van-stepper__input) {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

.group-list {
  margin-top: 12px;
}

.group-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  margin-bottom: 10px;
  overflow: hidden;
}

.group-disabled {
  opacity: 0.62;
}

.group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.group-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.group-head-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.group-flag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
}

.flag-on {
  background: rgba(45, 212, 191, 0.12);
  color: #0d9488;
}

.flag-off {
  background: #f1f5f9;
  color: #94a3b8;
}

.group-summary {
  padding: 6px 16px 10px;
  cursor: pointer;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.summary-label {
  font-size: 13px;
  color: #94a3b8;
  flex-shrink: 0;
}

.summary-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.summary-muted {
  color: #cbd5e1;
  font-weight: 500;
}

.summary-warn {
  color: #b45309;
}

.section-hint {
  font-size: 12px;
  color: #2dd4bf;
  font-weight: 500;
}

.popup-tip {
  padding: 6px 16px 10px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.5;
}

.range-section {
  padding: 14px 16px;
}

.range-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
}

.range-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.range-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.range-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

.range-input {
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  background: #f8fafc;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.range-input:focus {
  outline: none;
  border-color: #2dd4bf;
  background: #ffffff;
}

.range-sep {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
  padding-top: 16px;
}

.section-icon {
  font-size: 18px;
  color: #2dd4bf;
  flex-shrink: 0;
}

.icon-inline {
  font-size: 16px;
  margin-right: 6px;
  vertical-align: middle;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
}

.weekday-section {
  padding: 14px 16px;
}

.weekday-section .section-title {
  justify-content: flex-start;
  gap: 6px;
  margin-bottom: 12px;
}

.day-selector {
  display: flex;
  justify-content: space-between;
  gap: 6px;
}

.day-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.day-btn.active {
  background: #2dd4bf;
  color: #fff;
}

.day-btn.inactive {
  background: #f1f5f9;
  color: #94a3b8;
}

.config-tip {
  padding: 0 16px 14px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.5;
}

.config-tip--center {
  text-align: center;
  padding-top: 10px;
}

.add-group-btn {
  width: calc(100% - 32px);
  margin: 12px 16px 0;
  height: 46px;
  border: 1.5px dashed #2dd4bf;
  border-radius: 12px;
  background: rgba(45, 212, 191, 0.06);
  color: #0d9488;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: transform 0.15s, opacity 0.15s;
}

.add-group-btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.add-group-btn:disabled {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
  transform: none;
}

.config-save-wrap {
  padding: 16px 0 24px;
  display: flex;
  justify-content: center;
}

.save-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s, opacity 0.15s;
  box-shadow: 0 4px 12px rgba(45, 212, 191, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 16px;
}

.save-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.save-btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.popup-body {
  padding: 8px 0;
}

.time-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.popup-footer {
  display: flex;
  gap: 10px;
  padding: 12px 16px 24px;
}

.popup-btn {
  flex: 1;
  height: 42px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s;
}

.popup-btn:active {
  transform: scale(0.96);
}

.popup-btn--confirm {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.popup-btn--cancel {
  background: #f1f5f9;
  color: #475569;
}

.popup-btn--danger {
  background: rgba(251, 113, 133, 0.12);
  color: #e11d48;
}

/* ── 信号保护：KA1 同款参数卡片 ── */
.config-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.config-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2dd4bf;
  flex-shrink: 0;
}

.config-card-header span {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.card-save-btn {
  height: 30px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
  transition: transform 0.15s;
  flex-shrink: 0;
}

.card-save-btn:active {
  transform: scale(0.95);
}

.card-save-btn:disabled {
  opacity: 0.6;
}

.config-card-body {
  padding: 4px 0;
}

.config-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  min-height: 40px;
}

.config-field-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.config-field-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stepper-label-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  margin-right: 12px;
  min-width: 0;
}

.stepper-desc {
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.3;
}

:deep(.van-stepper) {
  flex-shrink: 0;
}

:deep(.van-stepper__minus),
:deep(.van-stepper__plus) {
  color: #2dd4bf;
  border-color: #2dd4bf;
}

:deep(.van-stepper__minus:active),
:deep(.van-stepper__plus:active) {
  background-color: #ccfbf1;
}

:deep(.van-stepper__input) {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

.config-radio {
  display: flex;
  gap: 6px;
}

.config-radio .van-radio__label {
  font-size: 13px;
  color: #475569;
}

.config-radio .van-radio__icon--checked .van-icon {
  background-color: #2dd4bf;
  border-color: #2dd4bf;
}
</style>
